import { PermissionEnum } from '@app/core/enums/permissions.enum';

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type,@typescript-eslint/ban-types
export function PermissionAware(constructor: Function) {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  constructor.prototype.Permission = PermissionEnum;
}
